export const blockIconsSearchDoorFront = (
	<span className='material-symbols-outlined'>door_front</span>
);
